import { styled } from '@mui/material/styles';
import { IconButton } from 'components/buttons';

export const FlexContainer = styled('div')(({ direction, alignItems }) => ({
  display: 'flex',
  flexDirection: direction || 'row',
  alignItems: alignItems || 'unset',
  width: '100%'
}));

export const TimeFieldEntry = styled('div')(() => ({
  display: 'flex',
  flex: 1,
  justifyContent: 'space-between',
  alignItems: 'baseline',
  margin: '10px 0',
  '& input': {
    width: '58px !important',
    marginRight: '45px',
    border: '2px solid #206af5',
    padding: '4px 7px'
  },
  '& input.de': {
    marginRight: '0px',
    marginLeft: '5px'
  },
  '& input.en': {
    marginRight: '0px',
    marginLeft: '15px'
  },
  '& input.error': {
    color: 'red'
  }
}));

export const AddBreakButton = styled('div')(({ theme }) => ({
  color: theme.color.primary.main,
  cursor: 'pointer',
  margin: '10px 0',
  fontWeight: 'bold'
}));

export const DeleteButton = styled(IconButton)(({ theme }) => ({
  alignSelf: 'center',
  padding: '0px',
  marginTop: '-5px',

  color: theme.color.danger.main,
  border: `1px solid transparent`,

  '&:hover': {
    border: `1px solid ${theme.color.danger.main}`
  },
  '&:active': {
    border: `1px solid ${theme.color.danger.main}`
  }
}));
